"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from "react";
import { cj, debounce, KEY_CODES } from "../utils";
import { SliderContext } from "./shared/sliderContext";
const SliderArrow = /*#__PURE__*/ React.forwardRef(function SliderArrow(_param, ref) {
    var { className = "", dir = "left", children } = _param, props = _object_without_properties(_param, [
        "className",
        "dir",
        "children"
    ]);
    const { goToNextSlide, goToPreviousSlide, hideArrows, slideAmount, slide: { current } } = React.useContext(SliderContext);
    const handleSlideChange = debounce(()=>{
        if (dir === "left") {
            goToPreviousSlide();
        } else {
            goToNextSlide();
        }
    });
    const isHidden = React.useMemo(()=>{
        if (dir === "left" && hideArrows && current === 0) return true;
        if (dir === "right" && hideArrows && current === slideAmount - 1) return true;
        return false;
    }, [
        dir,
        hideArrows,
        current,
        slideAmount
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, props), {
        onClick: handleSlideChange,
        onKeyDown: (e)=>{
            e.stopPropagation();
            if (e.key === KEY_CODES.ENTER || e.key === KEY_CODES.SPACE) {
                e.preventDefault();
                handleSlideChange();
            }
        },
        role: "button",
        tabIndex: 0,
        className: cj(className, `w-slider-arrow-${dir}`),
        "aria-label": `${dir === "left" ? "previous" : "next"} slide`,
        style: {
            display: isHidden ? "none" : "block"
        },
        ref: ref
    }), children);
});
export default SliderArrow;
